import React, { useEffect } from 'react';
import { useDispatch, useSelector, connect } from 'react-redux';
import { Spin } from 'antd';
import { withRoute } from 'util/withRoute';

import { fetchEventNotes } from 'modules/Lead/LeadActions';
import { fetchLeadDetails } from 'modules/LeadManage/LeadManageActions';
import {
    getLeadDetails,
    getSelectedLeadId
} from 'modules/LeadManage/LeadManageReducer';

import { getTotalAgentMap } from 'modules/App/AppReducer';
import { fetchFullAgentList } from 'modules/App/AppActions';

import { fetcheventNotesLoadingState } from 'modules/Lead/LeadReducer';

const CommentList = ({ lead, totalAgentMap, ...props }) => {
    const dispatch = useDispatch();

    const allEventNotes = useSelector(
        (state) =>
            state.leads?.eventNoteMap?.[lead?.event]?.eventNoteList || []
    );

    const isLoading = useSelector((state) =>
        fetcheventNotesLoadingState(state)
    );

    useEffect(() => {
        const idToUse = props.leadid || props.params?.leadId;

        if (idToUse) {
            dispatch(fetchLeadDetails(idToUse));
        }

        dispatch(fetchFullAgentList());
    }, [dispatch, props.leadid, props.params?.leadId]);

    useEffect(() => {
        if (lead?.event) {
            dispatch(fetchEventNotes(lead.event, {}));
        }
    }, [dispatch, lead?.event]);

    const insideSalesAgentIds = Object.values(totalAgentMap || {})
        .filter(
            (agent) =>
                agent?.designation === 'Inside Sales Executive' ||
                agent?.designation === 'Manager - Inside Sales'
        )
        .map((agent) => agent._id);

    const filteredNotes = allEventNotes.filter((note) =>
        insideSalesAgentIds.includes(note.agent_id)
    );

    return (
        <div
            style={{
                padding: '10px',
                maxWidth: '100%',
                fontFamily: '"Segoe UI", Roboto, sans-serif'
            }}
        >
            <h3
                style={{
                    fontSize: '20px',
                    fontWeight: '600',
                    marginBottom: '20px',
                    color: '#2c3e50',
                    borderBottom: '2px solid #3498db',
                    display: 'inline-block',
                    paddingBottom: '5px'
                }}
            >
                Active Notes ({filteredNotes.length})
            </h3>

            {isLoading ? (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        minHeight: '200px'
                    }}
                >
                    <Spin size="large" tip="Loading Notes..." />
                </div>
            ) : (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '15px'
                    }}
                >
                    {filteredNotes.length > 0 ? (
                        filteredNotes.map((note) => {
                            const agentData =
                                totalAgentMap[note.agent_id];

                            const agentName = agentData
                                ? agentData.name
                                : 'System User';

                            return (
                                <div
                                    key={note._id}
                                    style={{
                                        padding: '15px',
                                        borderRadius: '8px',
                                        backgroundColor: '#f8fbff',
                                        borderLeft:
                                            '5px solid #3498db',
                                        boxShadow:
                                            '0 2px 4px rgba(0,0,0,0.05)',
                                        width: '100%',
                                        boxSizing: 'border-box'
                                    }}
                                >
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent:
                                                'space-between',
                                            alignItems: 'flex-start',
                                            flexWrap: 'wrap',
                                            gap: '10px',
                                            marginBottom: '10px'
                                        }}
                                    >
                                        <span
                                            style={{
                                                fontWeight: 'bold',
                                                color: '#1a73e8',
                                                fontSize: '16px'
                                            }}
                                        >
                                            {agentName}
                                        </span>

                                        <span
                                            style={{
                                                color: '#7f8c8d',
                                                fontSize: '13px',
                                                backgroundColor:
                                                    '#fff',
                                                padding: '2px 8px',
                                                borderRadius: '4px',
                                                border:
                                                    '1px solid #eee'
                                            }}
                                        >
                                            {new Date(
                                                note.created_at
                                            ).toLocaleString(
                                                'en-GB',
                                                {
                                                    day: '2-digit',
                                                    month: 'short',
                                                    hour: '2-digit',
                                                    minute: '2-digit'
                                                }
                                            )}
                                        </span>
                                    </div>

                                    <div
                                        style={{
                                            color: '#444',
                                            fontSize: '15px',
                                            lineHeight: '1.5',
                                            wordBreak:
                                                'break-word'
                                        }}
                                    >
                                        {note.text}
                                    </div>
                                </div>
                            );
                        })
                    ) : (
                        <div
                            style={{
                                textAlign: 'center',
                                padding: '30px',
                                color: '#999',
                                border: '1px dashed #ccc',
                                borderRadius: '8px'
                            }}
                        >
                            No notes found.
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

function mapStateToProps(state, props) {
    return {
        leadid: props.params?.leadid,
        leadId: getSelectedLeadId(state),
        lead: getLeadDetails(state),
        totalAgentMap: getTotalAgentMap(state)
    };
}

export default connect(mapStateToProps)(
    withRoute(CommentList)
);